import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SelectItem } from 'primeng/api';
import { TranslateConfigService } from 'src/app/core/services/translate-config.service';
import { SfcWoOrderClientService } from 'src/app/core/services/wo-order/sfc-order-client.service';
import { SfcWoOrderClientOutput } from 'src/app/models/response/sfc-wo-order-client.model';
import { BreadCrumb } from 'src/app/shared/components/sf-breadcrumb/sf-breadcrumb.model';
import { ScCompanyInfoInput, ScCompanyOutput } from 'src/app/pages/sc-company/sc-company.model';
import { ScCompanyService } from 'src/app/pages/sc-company/sc-company.service';
import { Router } from '@angular/router';
import { ScUser, ScUserMessageList, ScUserMessageOutput } from 'src/app/models/response/sc-user.model';
import { ScUserService } from 'src/app/core/services/sc/sc-user.service';
import { UserToken } from 'src/app/core/auth.model';
import { UserTokenService } from 'src/app/core/services/user-token.service';
import { Observable, timer, takeUntil, Subject } from 'rxjs';
import { WoOrderSortingService } from 'src/app/core/services/wo-order/wo-order-sorting.service';
import { WoOrderOutput } from 'src/app/features/wo-order/wo-order.model';

@Component({
    selector: 'app-sfc-dashboard-client',
    templateUrl: './sfc-dashboard-client.component.html',
    styleUrls: ['./sfc-dashboard-client.component.scss'],
    // styles: [`
    //     @media screen and (max-width: 960px) {
    //         :host ::ng-deep .fc-header-toolbar {
    //             display: flex;
    //             flex-wrap: wrap;
    //         }
    //     }
    // `]
})
export class SfcDashboardClientComponent implements OnInit {


    private readonly POLLING_INTERVAL = 30000; // 30 seconds
    private taskLoading$ = new Subject<boolean>();
    private destroy$ = new Subject<void>();

    public userId?: string;
    public orderList: SfcWoOrderClientOutput[] = [];
    public orderListOpened: SfcWoOrderClientOutput[] = [];
    public orderListClosed: SfcWoOrderClientOutput[] = [];
    public chatList: ScUserMessageOutput[] = [];
    public activeOrder: number = 0;
    public screenHeightOrder: string = window.innerWidth > 120 ? (window.innerHeight - 530).toString() + 'px' : '400px';
    public screenHeightChat: string = window.innerWidth > 120 ? (window.innerHeight - 500).toString() + 'px' : '400px';
    public language: string = "pt-BR";
    public pageMessage: string = "";



    readonly AVATAR_COLOR_FROM = '#908871';
    readonly AVATAR_COLOR_OWN = "#6AA84F";
    public userAcronym: string = 'SC'; // Default acronym, can be set dynamically based on user data

    fullcalendarOptions: any;

    displaySendMessage: boolean = false;
    dialogHeaderSendMessage: string = '';
    woOrder: WoOrderOutput = {};

    constructor(private orderClientService: SfcWoOrderClientService,
        private userService: ScUserService,
        private userTokenService: UserTokenService,
        private translateService: TranslateService,
        private translateConfigService: TranslateConfigService,
        private router: Router,
        private orderSortingService: WoOrderSortingService) {

    }

    ngOnInit() {



        // const firstletter = firstName[0].toLocaleUpperCase();
        // const lastletter = lastName[0].toLocaleUpperCase();
        // const userAcronym = `${firstletter}${lastletter}`;
        this.userId = this.userTokenService.getUserId();
        this.getList();
        this.getMessage();
        this.translate();
    }

    getList() {
        this.orderClientService.getList().subscribe(
            {
                next: (res) => {
                    if (res) {
                        this.orderList = res.data;
                        this.orderListClosed = this.orderList.filter(item => item.isClosed);
                        this.orderListOpened = this.orderList.filter(item => !item.isClosed);
                    }
                },
                error: (err) => {
                    console.log(`SfcWoOrderClientGrid - getList : ${err}.`);
                }
            });
    }

    getMessage() {
        this.userService.getListUserMessage("TargetUserId_SourceUserId = " + this.userId).subscribe(
            {
                next: (res) => {
                    if (res) {
                        this.chatList = res.data;
                    }
                },
                error: (err) => {
                    console.log(`SfcWoOrderClientGrid - getMessage : ${err}.`);
                }
            });
    }

    getInitials(name: string): string {
        if (!name || typeof name !== 'string' || name.trim() === '') {
            return '??'; // Default for invalid or empty names
        }

        const nameParts = name.trim().split(/\s+/);

        if (nameParts.length === 0) {
            return '??';
        }

        const firstInitial = nameParts[0].charAt(0).toUpperCase();

        if (nameParts.length > 1) {
            const lastInitial = nameParts[nameParts.length - 1].charAt(0).toUpperCase();
            return firstInitial + lastInitial;
        } else {
            // Only one name part, use its first letter twice
            return firstInitial + firstInitial;
        }
    }


    changeOrder(index: number) {
        this.activeOrder = index;
        this.orderList = index === 0 ? this.orderListOpened : this.orderListClosed;
    }

    newService() {
        this.router.navigate(['/order/client-new']);
    }

    myServices() {
        this.router.navigate(['/order/client-my-orders']);
    }

    myData() {
        this.router.navigate(['/user-profile']);
    }

    getOrder(item: any) {

    }

    translate() {
        this.language = this.translateConfigService.getLanguage();

        const sleep = (ms) => new Promise(r => setTimeout(r, ms));
        (async () => {
            await sleep(50);
            //  const lab0 = this.translateService.instant('label.home') + ' ';
            //  const lab1 = ' ' + this.translateService.instant('label.serviceSorting');

            // this.BREAD_CRUMB_LIST = [
            //     {label: lab0,routerLink: '/',selected: false},
            //     {label: lab1,routerLink: '/order/order-sorting',selected: true}
            // ]


            this.pageMessage = this.translateService.instant('grid.showing') + " {first} " + this.translateService.instant('grid.to') + " {last} " + this.translateService.instant('grid.of') + " {totalRecords} " + this.translateService.instant('grid.entries')
        })();



    }

    openDialogSendMessage(woOrderId: string) {

        this.orderSortingService.getItem(woOrderId).subscribe(
            {
                next: (res) => {
                    if (res) {
                        this.woOrder = res.data;
                        if (this.woOrder != null && this.woOrder != undefined && (this.woOrder.obs == null || this.woOrder.obs == undefined || this.woOrder.obs == '')) {
                            this.woOrder.obs = ' - ';
                        }

                        this.displaySendMessage = true;
                        this.dialogHeaderSendMessage = this.translateService.instant('message.new_message');
                    }
                },
                error: (err) => {
                    console.log(`SfcDashboardServiceComponent - openDialogSendMessage : ${err}.`);
                    console.log(err);
                }
            });
    }

       /**
     * Sets up a polling mechanism that calls `onGetStatusNext` every 10 seconds
     * to refresh the available actions for the order.
     */
    private setupPollingForStatus(): void {
        // Start after 10 seconds, then repeat every 10 seconds.
        timer(this.POLLING_INTERVAL, this.POLLING_INTERVAL)
            .pipe(takeUntil(this.taskLoading$ || this.destroy$))
            .subscribe(() => {
                this.getList();
            });
    }


}
